import { UserMembersActionWire } from '../types';
import { ListAction } from '../types-store';

export const mapActionsToWire = (actions: ListAction[]): UserMembersActionWire[] =>
  actions?.map(action => ({
    userId: action.path[action.path.length - 1],
    action: action.type
  })) ?? [];
